import {
    queryEnabledLocations,
    getLocationsEnabled,
    getLocationById,
    createLocation,
    updateLocation,
    deleteLocation,
    restoreLocation,
    getEnabledLocationsByIds,
} from '../locations/locationsService';

const DEPOT_TYPES = ['DEPOT'];

export async function queryEnabledDepots(params = {}) {
    return queryEnabledLocations({ ...params, locationTypes: DEPOT_TYPES });
}

export async function getDepotsEnabled(params = {}) {
    return getLocationsEnabled({ ...params, locationTypes: DEPOT_TYPES });
}

export async function getDepotById(id, signal = null) {
    return getLocationById(id, signal);
}

export async function createDepot(payload, signal = null) {
    return createLocation({ ...payload, locationType: 'DEPOT' }, signal);
}

export async function updateDepot(id, payload, signal = null) {
    return updateLocation(id, { ...payload, locationType: 'DEPOT' }, signal);
}

export async function deleteDepot(id, signal = null) {
    return deleteLocation(id, signal);
}

export async function restoreDepot(id, signal = null) {
    return restoreLocation(id, signal);
}

export async function getEnabledDepotsByIds(ids, signal = null) {
    return getEnabledLocationsByIds(ids, signal);
}
